module.exports = __webpack_public_path__ + "img/candy_cane.28086de5.svg";